<app-load-dropdown-data [formName]="formName" (fillDropdownData)="fillDropdownData()"></app-load-dropdown-data>
<div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <div><span class="font-semibold text-primary">{{data?.modalTitle }}</span></div>
    <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
    <app-svg-icon [name]="'cross'" [ngClass]="currentHoverEffect" class="cross-button" (click)="activeModal.dismiss()"></app-svg-icon>
</div>
<form autocomplete="off" class="theme-form" ngNativeValidate #AdditionalAmountForm="ngForm">
    <div class="modal-body px-1 pb-0">
        <div class="row mx-0 gap-2 flex-fill">
            <div class="col p-0">
                <div class="h-100 position-relative">
                    <app-ag-grid 
                        id="AdditionalAmount" 
                        [dataModel]="agGridDataModelAdditionalAmount" 
                        (onCellKeyDownValue)="calculateTotalAmount($event)"
                        (cellValueChanged)="cellValueChanged($event)"
                        (onDeleteIconClick)="onDeleteIconClick($event)"
                        (gridReady)="onGridReady($event)">
                    </app-ag-grid>
                </div>
            </div>
        </div>
        <div class="row d-flex flex-fill">
            <div class="col-12  transactiontable">
                <table class="table table-bordered">
                    <tbody>
                        <tr class="d-flex align-items-center p-0 tabel-bg-color">
                            <td width="100%" class="text-start color-dark-gray font-semibold border-bottom-0 border-right-0 border-top-0 tabel-bg-color"> Total</td>
                            <td width="40%" class="pe-2 text-center color-dark-gray font-regular border-0 px-0 tabel-bg-color"> {{ TotalAmount | number: '1.2-2' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <hr class="mt-0 mb-2">
        <div class="d-flex py-1  align-items-center justify-content-center cursorPointer blue_button2 f-14 font-semibold"
            (click)="OnSaveAdditionalAmount()">
            Done
        </div>
    </div>
</form>